import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
    containerSelectLabels: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "1rem",
    },
    selectLabel: {
        width: "5rem",
        padding: "0.15rem 0",
        border: theme.palette.type === "dark"
            ? "1px solid rgba(255, 255, 255, 0.12)"
            : "1px solid #ced4da",
        textTransform: "none",
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
        transition: "background-color 150ms ease-in-out, color 150ms ease-in-out, border-color 150ms ease-in-out",
        "&:hover": {
            borderColor: theme.palette.type === "dark"
                ? "rgba(255, 255, 255, 0.2)"
                : "#94a3b8",
            backgroundColor: theme.palette.type === "dark"
                ? "rgba(37, 99, 235, 0.15)"
                : "rgba(37,99,235,0.06)",
        },
    },
    selectLabelActive: {
        backgroundColor: "#2563eb",
        borderColor: "#2563eb",
        color: "#ffffff",
        transition: "background-color 150ms ease-in-out, color 150ms ease-in-out, border-color 150ms ease-in-out",
        "&:hover": {
            borderColor: "#2563eb",
            backgroundColor: "#2563eb",
        },
    },
}));

export default function PeriodLabelsSelectorChart({ 
    chartType, 
    labelsText = [], 
    queueDurationData,
    matchesChartPeriod,
    matchmakingCapacityPeriod,
    signupsChartPeriod,
    onClickHandlers 
}) {
    const classes = useStyles();
    const { 
        getSevenDaysDataForQueueChart,
        getThirtyDaysDataForQueueChart,
        getNinetyDaysDataForQueueChart,
        getSevenDaysDataForMatchmakingChart,
        getThirtyDaysDataForMatchmakingChart,
        getNinetyDaysDataForMatchmakingChart,
        getSevenDaysDataForMatchmakingCapacityChart,
        getThirtyDaysDataForMatchmakingCapacityChart,
        getNinetyDaysDataForMatchmakingCapacityChart,
        getWeeklyData,
        getMonthlyData,
        getYearlyData
    } = onClickHandlers || {};

    return (
        <>
            {chartType == "queueDuration" ? (
                <>
                    <Button 
                        disableRipple 
                        disableElevation 
                        className={`${classes.selectLabel} ${queueDurationData === "seven_days" ? classes.selectLabelActive : ""}`} 
                        onClick={getSevenDaysDataForQueueChart}
                    >
                        {labelsText[0]}
                    </Button>
                    <Button 
                        disableRipple 
                        disableElevation 
                        className={`${classes.selectLabel} ${queueDurationData === "thirty_days" ? classes.selectLabelActive : ""}`} 
                        onClick={getThirtyDaysDataForQueueChart}
                    > 
                        {labelsText[1]}
                    </Button>
                    <Button 
                        disableRipple 
                        disableElevation 
                        className={`${classes.selectLabel} ${queueDurationData === "ninety_days" ? classes.selectLabelActive : ""}`} 
                        onClick={getNinetyDaysDataForQueueChart}
                    >
                        {labelsText[2]}
                    </Button>
                </>
            ) : chartType === "matchmakingActivity" ? (
                <>
                    <Button 
                        disableRipple 
                        disableElevation 
                        className={`${classes.selectLabel} ${matchesChartPeriod === "seven_days" ? classes.selectLabelActive : ""}`} 
                        onClick={getSevenDaysDataForMatchmakingChart}
                    >
                        {labelsText[0]}
                    </Button>
                    <Button 
                        disableRipple 
                        disableElevation 
                        className={`${classes.selectLabel} ${matchesChartPeriod === "thirty_days" ? classes.selectLabelActive : ""}`} 
                        onClick={getThirtyDaysDataForMatchmakingChart}
                    > 
                        {labelsText[1]}
                    </Button>
                    <Button 
                        disableRipple 
                        disableElevation 
                        className={`${classes.selectLabel} ${matchesChartPeriod === "ninety_days" ? classes.selectLabelActive : ""}`} 
                        onClick={getNinetyDaysDataForMatchmakingChart}
                    >
                        {labelsText[2]}
                    </Button>
                </>
            ) : chartType === "matchmakingCapacity" ? (
                <>
                    <Button 
                        disableRipple 
                        disableElevation 
                        className={`${classes.selectLabel} ${matchmakingCapacityPeriod === "seven_days" ? classes.selectLabelActive : ""}`} 
                        onClick={getSevenDaysDataForMatchmakingCapacityChart}
                    >
                        {labelsText[0]}
                    </Button>
                    <Button 
                        disableRipple 
                        disableElevation 
                        className={`${classes.selectLabel} ${matchmakingCapacityPeriod === "thirty_days" ? classes.selectLabelActive : ""}`} 
                        onClick={getThirtyDaysDataForMatchmakingCapacityChart}
                    > 
                        {labelsText[1]}
                    </Button>
                    <Button 
                        disableRipple 
                        disableElevation 
                        className={`${classes.selectLabel} ${matchmakingCapacityPeriod === "ninety_days" ? classes.selectLabelActive : ""}`} 
                        onClick={getNinetyDaysDataForMatchmakingCapacityChart}
                    >
                        {labelsText[2]}
                    </Button>
                </>
            ) : (
                <>
                    <Button
                        disableRipple
                        disableElevation
                        className={`${classes.selectLabel} ${signupsChartPeriod === "week" ? classes.selectLabelActive : ""}`}
                        onClick={getWeeklyData}
                    >
                        {labelsText[0]}
                    </Button>
                    <Button
                        disableRipple
                        disableElevation
                        className={`${classes.selectLabel} ${signupsChartPeriod === "month" ? classes.selectLabelActive : ""}`}
                        onClick={getMonthlyData}
                    >
                        {labelsText[1]}
                    </Button>
                    <Button
                        disableRipple
                        disableElevation
                        className={`${classes.selectLabel} ${signupsChartPeriod === "year" ? classes.selectLabelActive : ""}`}
                        onClick={getYearlyData}
                    >
                        {labelsText[2]}
                    </Button>
                </>
            )}
        </>
    );
}

